module.exports = __webpack_public_path__ + "static/media/dangerIcon.9632b79d.svg";